export default __webpack_public_path__ + "static/media/EggplantParm.f9389ada.jpg";